// extracted by mini-css-extract-plugin
module.exports = {"board":"BoardPlaceholder_board__2M9bv","settings":"BoardPlaceholder_settings__2l3AG","hover":"BoardPlaceholder_hover__1rUQ2","delete":"BoardPlaceholder_delete__2sZ-s"};